// extracted by mini-css-extract-plugin
export default {"heading":"MyCertifications_heading__rSO8N","gridListing":"MyCertifications_gridListing__InZs1","list":"MyCertifications_list__I6Fet"};